import { StaticImageData } from "next/image";
import React, { ReactNode } from "react";
import Image from "next/image";

type WorkProps = {
    heading: string;
    link: string;
    altText: string;
    imageSrc: string | StaticImageData;
    className: React.ReactNode | null;
};

export default function WorkThumbnail({
    heading,
    link,
    imageSrc,
    altText,
    className,
}: WorkProps) {
    return (
        <a
            href={link}
            className={
                "flex flex-col text-center gap-y-3 group mb-5 mx-[1%] sm:w-[48%] lg:w-1/3 work " +
                className
            }
            // target="_blank"
        >
            <div className="rounded-3xl sm:rounded-[2rem] overflow-clip">
                <Image
                    src={imageSrc}
                    width={488}
                    height={300}
                    alt={altText}
                    className=" group-hover:scale-105 sca duration-300"
                    loading="lazy"
                />
            </div>
            <p className=" font-semibold mb-0 px-4">{heading}</p>
        </a>
    );
}
